import { Box, Typography } from "@mui/material";
import { useState } from "react";
import useColors from "../../../../api/hooks/useColors";
import { getConditionOptions } from "../data/workflowOptions";
import OptionSelector from "./OptionSelector";

const ConditionSelector = ({
  conditionTypes,
  onConditionSelect,
  onCancel,
  placeholder = "Select condition type...",
}) => {
  const colors = useColors();
  const [selectedType, setSelectedType] = useState(null);
  const [showTypeSelector, setShowTypeSelector] = useState(true);
  const [showOptionSelector, setShowOptionSelector] = useState(false);

  const handleTypeSelect = (type) => {
    setSelectedType(type);
    setShowTypeSelector(false);
    setShowOptionSelector(true);
  };

  const handleOptionSelect = (option) => {
    const conditionWithType = {
      ...option,
      typeChildren: option.type,
      type: selectedType,
      fullName: `${selectedType.name} ${option.name}`,
      id: `${selectedType.id}_${option.id}`,
    };

    // Immediately pass the condition to parent and close
    onConditionSelect(conditionWithType);
  };

  const handleCancel = () => {
    if (showOptionSelector) {
      // Go back to type selection
      setShowOptionSelector(false);
      setShowTypeSelector(true);
      setSelectedType(null);
    } else {
      // Cancel completely
      onCancel();
    }
  };

  return (
    <Box>
      {/* Type selector */}
      {showTypeSelector && (
        <OptionSelector
          options={conditionTypes}
          onSelect={handleTypeSelect}
          onCancel={handleCancel}
          placeholder={placeholder}
        />
      )}

      {/* Option selector for selected type */}
      {showOptionSelector && selectedType && (
        <Box>
          <Typography
            variant="caption"
            sx={{
              color: colors.text_secondary,
              marginBottom: 1,
              display: "block",
            }}
          >
            {selectedType.name}
          </Typography>
          <OptionSelector
            options={getConditionOptions(selectedType)}
            onSelect={handleOptionSelect}
            onCancel={handleCancel}
            placeholder={`Select ${selectedType.name.toLowerCase()} option...`}
            ParentSelectedOption={selectedType}
          />
        </Box>
      )}
    </Box>
  );
};

export default ConditionSelector;
